export interface InterfaceFlow {
  id: number;
  exportador: string;
  interface: string;
  index: string;
}

export type InterfacePayload = Omit<InterfaceFlow, "id">;

export type InterfaceFormErrors = Partial<
  Record<keyof InterfacePayload, string>
>;

export interface InterfacesApiResponse {
  success: boolean;
  data: InterfaceFlow[];
}

export const INTERFACE_FIELDS: Array<keyof InterfacePayload> = [
  "exportador",
  "interface",
  "index",
];

export const emptyInterface: InterfacePayload = {
  exportador: "",
  interface: "",
  index: "",
};
